<lib-dialog [title]="title" (closeButtonClick)="closeDialog()">
  <div *ngIf="googleMapsEmbedLink" body class="iframe-container">
    <iframe
      [src]="googleMapsEmbedLink | sanitizerByTrust"
      width="100%"
      height="100%"
      style="border: 0"
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>

  <ng-container action>
    <lib-spacer></lib-spacer>
    <button mat-stroked-button (click)="closeDialog()">
      {{ 'google-maps-embed-iframe-dialog.buttons.close' | translate }}
    </button>
    <lib-spacer></lib-spacer>
  </ng-container>
</lib-dialog>
